/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query CustomersoverviewQuery($uid: String!) {
    prismic {
      customersoverview(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_CustomersoverviewBodyHerocarousel {
          type
            fields {
              author
              company
              position
              logo
              avatar
              quote
              quote_color
              wistia_video_id
            }
            primary {
              background_color
              background_image
              heading
              heading_color
              subheading
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_CustomersoverviewBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        },
        ... on PRISMIC_CustomersoverviewBodyLeftslidingnavcards {
          type
            primary {
              background_color
              background_image
              text_color
              cta_button_text
              cta_button_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_button_color
            }
            label
            fields {
              heading
              heading_color
              subheading
              subheading_color
              card_1_copy
              card_1_image
              card_1_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_1_title
              card_2_copy
              card_2_image
              card_2_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_2_title
              card_3_copy
              card_3_image
              card_3_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_3_title
              card_4_copy
              card_4_image
              card_4_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_4_title
              card_5_copy
              card_5_image
              card_5_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_5_title
              card_6_copy
              card_6_image
              card_6_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_6_title
              card_7_copy
              card_7_image
              card_7_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_7_title
              card_8_copy
              card_8_image
              card_8_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_8_title
              card_9_copy
              card_9_image
              card_9_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_9_title
            }
        },
        ... on PRISMIC_CustomersoverviewBodyHerotextbranded {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              brand_logo
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_CustomersoverviewBodyHerocarouselv2 {
          type
fields {
  background_image
  background_color
  cta_button_text
  heading
  cta_button_url {
    ... on PRISMIC__ExternalLink {
      _linkType
      url
    }
  }
  image
  large_heading
  subheading
  text_alignment
  text_color
  video_cta_text
  video_timestamp
  video_wistia_id
  video_thumbnail_image
  display_cta_button
  brand_logo
}
        },
        ... on PRISMIC_CustomersoverviewBodyCustomerstorycarousel {
          type
          label
          primary {
            background_color
            heading
            subheading1
            text_color
            heading_color
            background_image
            subheading_color
          }
          fields {
            customer_story_text
            customer_story_icon
            customer_story_image
            customer_story_name
            customer_story_company
          }
        },
        ... on PRISMIC_CustomersoverviewBodyCardsmasonry {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
              image_play_button
              filter_value_1
              filter_value_2
              filter_value_3
              filter_value_4
              filter_value_5
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
              show_filter
              dropdown_item_1
              dropdown_item_2
              dropdown_item_3
              dropdown_item_4
              dropdown_item_5
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Customersoverview = ({ data, location }) =>
  data.prismic.customersoverview ? (
    <MainLayout location={location} layout='customersoverview'>
    <Helmet>
      <title>{(data.prismic.customersoverview.title[0] && data.prismic.customersoverview.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.customersoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.customersoverview.path : 'https://www.digitalocean.com' + data.prismic.customersoverview.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.customersoverview.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.customersoverview.title[0] ? data.prismic.customersoverview.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.customersoverview.description ? data.prismic.customersoverview.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.customersoverview.open_graph_image ? data.prismic.customersoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.customersoverview.description ? data.prismic.customersoverview.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.customersoverview.title[0] ? data.prismic.customersoverview.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.customersoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.customersoverview.path : 'https://www.digitalocean.com' + data.prismic.customersoverview.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.customersoverview.open_graph_image ? data.prismic.customersoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.customersoverview.body} />
    </MainLayout>
  ) : null;

Customersoverview.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Customersoverview;
